import {ProcessFlowchartPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';

import {SidepanelTab} from './processFlowchartConfigEditorConstants';
import {TaskSchemaNode} from './processFlowchartConfigEditorNodeTypes';
import {PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE} from './processFlowchartConfigEditorRegistry';

export default function getAllNodeDetailsSidepanelTabsForTaskNode(
  node: TaskSchemaNode,
  platformFlowchartFeatures?: Map<ProcessFlowchartPlatformFeatureType, boolean>
): Array<SidepanelTab> {
  if (platformFlowchartFeatures == null) {
    return [];
  }
  const platformFeatureSidepanelTabs = [...node.data.nodeDetailsSidepanelContent];

  for (const [feature, enabled] of platformFlowchartFeatures) {
    if (enabled && PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[feature] != null) {
      const tabs = PROCESS_FLOWCHART_SIDEPANEL_TAB_BY_PLATFORM_FEATURE[feature];
      platformFeatureSidepanelTabs.push(...tabs);
    }
  }
  return platformFeatureSidepanelTabs;
}
